import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "calendar-selection__label" }
const _hoisted_3 = { class: "calendar-selection" }
const _hoisted_4 = { class: "calendar-selection__day" }
const _hoisted_5 = { class: "calendar-selection__top" }
const _hoisted_6 = { class: "ms-1" }
const _hoisted_7 = { class: "calendar-selection__bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.ISODate)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.label), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getLocaleDayOfMonthOfISO(_ctx.ISODate)), 1),
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.getLocaleMonthNameOfISO(_ctx.ISODate)) + " ", 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.getLocaleYearOfISO(_ctx.ISODate)), 1)
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.getLocaleDayNameOfISO(_ctx.ISODate, 'long')), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}